/**
 * Estado de exibição do bloco defeito/motivo/observações no modal V2.
 */
export function getDefeitoDisplayState(defeitoData, motivoDisplay) {
  const motivo = String(motivoDisplay ?? '').trim();
  const obsGeral = String(defeitoData?.observacaoGeral ?? '').trim();
  const defeitoNome = String(defeitoData?.defeito ?? '').trim();
  const hasDefeito =
    Boolean(defeitoData?.codDefeito) || (defeitoNome.length > 0 && defeitoNome !== 'Não informado');
  const hasMotivo = motivo.length > 0;
  const hasObsGeral = obsGeral.length > 0;
  const obsGeralProminent = !hasMotivo && !hasDefeito && hasObsGeral;
  const showObsGeralInExpanded = !obsGeralProminent;

  return {
    hasDefeito,
    hasMotivo,
    hasObsGeral,
    obsGeral,
    obsGeralProminent,
    showObsGeralInExpanded,
  };
}
